<template>
  <div class="row">
    <div class="col-md-12">
      <table
        :id="tableId"
        class="table table-striped table-bordered table-full-width"
      >
        <tbody />
      </table>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Datatable',
  props: {
    tableId: {
      type: String,
      required: true
    },
    columns: {
      type: Array,
      required: true
    },
    url: {
      type: String,
      required: true
    },
    params: {
      type: Object,
      default: () => ({})
    },
    order: {
      type: Array,
      default: () => []
    },
    options: {
      type: Object,
      default: () => ({})
    },
    isWatchParams: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      oTable: null
    }
  },
  computed: {
    createdAtIndex () {
      return this.columns.findIndex(column => column.data === 'created_at')
    }
  },
  watch: {
    '$i18n.locale' () {
      this.reinitialise()
    },
    params () {
      if (this.isWatchParams) {
        this.oTable.draw()
      }
    }
  },
  mounted () {
    this.oTable = this.datatable()
  },
  methods: {
    reinitialise () {
      try {
        this.oTable.destroy()
        this.oTable = null
        this.oTable = this.datatable()
        // eslint-disable-next-line no-empty
      } catch (error) {}
    },
    draw () {
      this.oTable.draw()
    },
    datatable () {
      let order = this.order
      if (!(this.order && this.order.length > 0)) {
        order = [[this.createdAtIndex, 'desc']]
      }
      const options = Object.assign({
        stateSave: true,
        processing: false,
        serverSide: true,
        scrollX: true,
        pageLength: 10,
        language: {
          url: `/locale/${this.$i18n.locale}.json`
        },
        ajax: {
          method: 'POST',
          url: `${process.env.VUE_APP_API}/${this.url}`,
          data: (t) => {
            const params = Object.assign({
              show: this.$t('label.show'),
              edit: this.$t('label.edit'),
              delete: this.$t('label.delete'),
              na: this.$t('string.na'),
              ...this.params
            }, this.params)

            for (const key in params) {
              t[key] = params[key]
            }
          },
          error: (xhr) => {
            this.onResponseError(xhr)
          },
          complete: () => {
            this.$isLoading(false)
          }
        },
        order,
        columns: this.columns,
        drawCallback () {
          $('[data-toggle="tooltip"]').tooltip()
        }
      }, this.options)
      return $(`#${this.tableId}`).DataTable(options)
    }
  }
}
</script>

<style scoped>

</style>
